import { extractPersonFromJsonLd } from './extractPerson';
export const extractMembers = jsonLd => {
  const members = jsonLd['atlassian:member'];
  if (members) {
    if (typeof members === 'string') {
      throw Error('Link[atlassian:members] must be an array or object.');
    } else if (members.hasOwnProperty('totalItems')) {
      const collection = members;
      if (collection.items) {
        return collection.items.map(member => extractPersonFromJsonLd(member)).filter(member => !!member);
      }
    } else {
      const memberItem = members;
      const memberItemForLink = extractPersonFromJsonLd(memberItem);
      if (memberItemForLink) {
        return [memberItemForLink];
      }
    }
  }
};